export function App() {
  return <main>glob.sh — placeholder</main>;
}
